import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router'

import { admin } from './admin'

// Api関係
import CognitoClient from '@/api/CognitoClient'

// utils
import LocalDataUtil from '@/utils/LocalDataUtil'
// import _ from 'lodash'
// import DisplayDataUtil from '../utils/DisplayDataUtil'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    admin
  },
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // ====================
    // Auth系
    // ====================
    signIn ({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        CognitoClient.signIn(payload.email, payload.password).then((result) => {
          if (result.challengeName && result.challengeName === 'NEW_PASSWORD_REQUIRED') {
            reject(new Error(JSON.stringify({
              nickname: result.challengeParam.userAttributes.nickname,
              email: result.challengeParam.userAttributes.email,
              session: result.Session
            })))
          } else {
            return CognitoClient.getCurrentSession()
          }
        }).then((session) => {
          console.log(session)
          if (session === undefined) return
          LocalDataUtil.setSession(session)
          router.push({ name: 'main' })
        }).catch(err => {
          throw err
        })
      })
    },
    logout ({ commit, state }) {
      return CognitoClient.signOut().then(() => {
        LocalDataUtil.removeSession()
        router.push({ name: 'signin' })
      })
    }
  }
})
